import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const ProblematicAreas = lazyWithPreload(
  () => import('./ProblematicAreas'),
)
export const ProblematicAreasV2 = lazyWithPreload(
  () => import('./ProblematicAreasV2'),
)
export const LikeChatProblematicAreas = lazyWithPreload(
  () => import('./LikeChatProblematicAreas'),
)
